import React, { useState } from "react";
import Button from "components/button";
import IndexModal from "components/modal";
import { Plus } from "lucide-react";


const NewItemButton = ({
    children, 
    buttonClass,
    textColor = "text-blue-600",    
    hoverBgColor = "hover:bg-blue-50",
    label = "New Ticket",
    bgColor = "bg-white",
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button
                onClick={() => setIsOpen(true)}
                className={`inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-semibold transition-all 
                            shrink-0 h-9 px-4 py-2 ${bgColor} ${textColor} ${hoverBgColor} gap-2 shadow-lg border border-white/30 ${buttonClass || ""}`}
            >
                <Plus className="w-4 h-4" />
                <span>{label}</span>
            </Button>

            <IndexModal
                open={isOpen}
                onClose={() => setIsOpen(false)}
                useCustomClass={true}
                maxContentHeight="85vh"
                width="500px"
            >
                {React.cloneElement(children, { onClose: () => setIsOpen(false) })}
            </IndexModal>
        </>
    );
};

export default NewItemButton;
